import { ReferelCodeActionTypes } from "./constants";

export interface ReferelCodeActionType {
  type:
    | ReferelCodeActionTypes.API_RESPONSE_SUCCESS
    | ReferelCodeActionTypes.API_RESPONSE_ERROR
    | ReferelCodeActionTypes.ADD_REFERELCODE
    | ReferelCodeActionTypes.UPDATE_REFERELCODE;

  payload: any;
}

// Common success
export const ReferelCodeApiResponseSuccess = (actionType: string, data: any): ReferelCodeActionType => ({
  type: ReferelCodeActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// Common error
export const ReferelCodeApiResponseError = (actionType: string, error: string): ReferelCodeActionType => ({
  type: ReferelCodeActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

// Add referel code
export const addReferelCode = (reference_id: string, type: string, code: string): ReferelCodeActionType => ({
  type: ReferelCodeActionTypes.ADD_REFERELCODE,
  payload: { reference_id, type, code },
});

// Update referel code
export const updateReferelCode = (
  id: string | number,
  type: string,
  referel_code: string,
  is_active: boolean,
  is_valid: boolean
): ReferelCodeActionType => ({
  type: ReferelCodeActionTypes.UPDATE_REFERELCODE,
  payload: { id, referel_code, type, is_active, is_valid },
});
